import React, { useEffect, useState } from "react";
import { Header } from "../../components/SpearParts/Layouts/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet-async";
import SEO from "../../components/SEO";
import {
  Card,
  Button,
  Container,
  Row,
  Col,
  Tab,
  Tabs,
  Image,
  InputGroup,
  Form,
} from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Axios from "../../axios/axios";
import ReviewModal from "./ReviewModal";
import ReviewCarousel from "./ReviewCarousel";
import CatalogueCard from "./CatalogueCard";
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import { toTitleCase } from "../../components/utils/StringUtil";

import ImageZoom from "react-image-zoom";
import { toast } from "react-toastify";
import Category from "./Category";
import TopNavBar from "../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../components/SpearParts/Layouts/TopSearchBar";

const SingleProduct = () => {
  const [tab, setTab] = useState("features");
  const [relatedProducts, setRelatedProducts] = useState([]);

  const [selectedImage, setSelectedImage] = useState(0);

  const product = {
    title: "Aurora Wireless Headphones — Noise Cancelling",
    brand: "Aurora Audio",
    price: 129.99,
    oldPrice: 179.99,
    rating: 4.6,
    reviewsCount: 248,
    badges: ["Bestseller", "Limited Offer"],
    images: [
      "/images/headphone-1.jpg",
      "/images/headphone-2.jpg",
      "/images/headphone-3.jpg",
      "/images/headphone-4.jpg",
    ],
    features: [
      "Active Noise Cancellation (ANC)",
      "30 hours battery life",
      "Quick charge: 10 min = 5 hours",
      "Bluetooth 5.3 with multipoint",
      "Lightweight & foldable design",
    ],
    catalogs: [
      { name: "Specs Sheet (PDF)", href: "/files/specs-aurora.pdf" },
      { name: "Warranty & Manual", href: "/files/manual-aurora.pdf" },
    ],
    reviews: [
      {
        name: "Priya",
        rating: 5,
        date: "2025-09-15",
        text: "Amazing ANC and very comfortable for long use.",
      },
      {
        name: "Rahul",
        rating: 4,
        date: "2025-08-30",
        text: "Great sound but could be lighter. Battery excellent.",
      },
      {
        name: "Maya",
        rating: 5,
        date: "2025-07-12",
        text: "Best in this price range. Highly recommend.",
      },
    ],
  };

  const formatPrice = (p) => `₹${p.toFixed(2)}`;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleLoginRedirect = () => {
    sessionStorage.setItem("postLoginRedirect", location.pathname);
    navigate(`/login?redirect=${encodeURIComponent(location.pathname)}`);
  };

  const location = useLocation();
  // const { spareBrand = [], spareCategory = [], spareModels = [], region = [] } = location.state || {};
  const [reviews, setReviews] = useState([]);
  const { id } = useParams();
  const [quantity, setQuantity] = useState(1); // quantity state for product
  const [message, setMessage] = useState("");
  const [isInCart, setIsInCart] = useState(false);
  const navigate = useNavigate();
  const [series, setSeries] = useState([]);
  const [brand, setBrand] = useState([]);
  const [region, setRegion] = useState([]);
  const [model, setModel] = useState([]);
  const [category, setCategory] = useState([]);
  const [parts, setParts] = useState([]);
  const [userInfo, setUserInfo] = useState(null);

  console.log("parts catelogue", reviews);

  const [mainImage, setMainImage] = useState("");

  useEffect(() => {
    if (parts?.images?.length > 0) {
      setMainImage(parts.images[0].url); // Set only the first image as the main image
    }
  }, [parts]);

  useEffect(() => {
    LoginData();
  }, []);

  useEffect(() => {
    getProdutData();

    fetchReview();
  }, [id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id, location.pathname]);

  useEffect(() => {
    if (parts.seriesId) {
      getSeries();
    }
    if (parts.brandId) {
      getBrand();
    }
    if (parts.modelId) {
      getModel();
    }
    if (parts.regionId) {
      getRegion();
    }
    {
      if (parts.categoryId) {
        getCategory();
      }
    }
  }, [parts]); // Runs when `parts.seriesId` changes

  useEffect(() => {
    if (parts?._id && userInfo?.customerId) {
      checkCart();
    }
  }, [parts, userInfo]); // Runs only when parts or userInfo changes

  useEffect(() => {
    const fetchRelatedProducts = async () => {
      if (parts.categoryId) {
        try {
          const res = await Axios.get(
            `/related-products?categoryId=${parts.categoryId}&excludeId=${parts._id}`
          );
          setRelatedProducts(res.data);
        } catch (error) {
          console.error("Error fetching related products:", error);
        }
      }
    };
    fetchRelatedProducts();
  }, [parts]);

  const LoginData = () => {
    const userInfoString = sessionStorage.getItem("userInfo");
    if (userInfoString) {
      const parsed = JSON.parse(userInfoString);
      setUserInfo(parsed);
    } else {
      console.log("No user info found in session storage.");
    }
  };

  const getProdutData = async () => {
    try {
      const res = await Axios.get(`/parts/get/${id}`);
      setParts(res.data);
    } catch (error) {}
  };

  const getSeries = async () => {
    try {
      const result = await Axios.get(`/series/get/${parts.seriesId}`);
      setSeries(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getModel = async () => {
    try {
      const result = await Axios.get(`/model/getsingle/${parts.modelId}`);
      setModel(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getRegion = async () => {
    try {
      const result = await Axios.get(`/region/get/${parts.regionId}`);
      setRegion(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getCategory = async () => {
    try {
      const result = await Axios.get(`/category/get/${parts.categoryId}`);
      setCategory(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getBrand = async () => {
    try {
      const result = await Axios.get(`/brand/get/${parts.brandId}`);
      setBrand(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReview = async () => {
    try {
      const response = await Axios.get(`review/search?partsId=${id}`);
      const reviewsData = response.data;

      const reviewsWithName = await Promise.all(
        reviewsData.map(async (review) => {
          let customerName = "Unknown";

          if (review.customerId) {
            try {
              const res = await Axios.get(`/customer/get/${review.customerId}`);
              customerName = res.data?.customerName || "Unknown"; // FIXED
            } catch (err) {
              console.error("Error fetching customer:", err);
            }
          }

          return {
            ...review,
            customerName,
            createdAt: review.createdAt || new Date(), // fallback date
          };
        })
      );

      setReviews(reviewsWithName);
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };

  const checkCart = async () => {
    try {
      console.log(parts?._id, userInfo?.customerId);

      const res = await Axios.get(
        `/cart/check/${parts?._id}/${userInfo?.customerId}`
      );
      console.log("API Response:", res.data);
      setIsInCart(res.data.exists);
    } catch (error) {
      console.error("Error checking cart status", error);
    }
  };

  const addToCart = async () => {
    try {
      // Create a cart object payload
      const cartData = {
        customerId: userInfo?.customerId, // Replace or retrieve from context/authentication
        businessType: "retail", // Example; adjust accordingly
        items: [
          {
            productId: parts?._id, // assuming productId is from params or part
            productName: parts?.name || "Product Name", // You might need to adjust
            productType: parts?.productType || "product Type",
            quantity: quantity,
            productType: parts?.productType || "productType",
            unitPrice: parts?.price || 0,
            totalItemPrice: (parts?.price || 0) * quantity,
            supplier: parts?.supplier.name,
          },
        ],
        tax: 10, // or calculate tax as per your business logic
      };

      // Send POST request to create a new cart (or add item to an existing one)
      const response = await Axios.post("/cart/create", cartData);
      // setMessage('Product added to cart successfully!');
      setIsInCart(true);

      toast.success("🦄 Product added to cart successfully!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        // transition: Bounce,
      });
    } catch (error) {
      console.error("Error adding to cart:", error);
      setMessage("Error adding product to cart.");
    }
  };

  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0]; // "YYYY-MM-DD"

  const addToOrder = async () => {
    try {
      const orderData = {
        customerId: userInfo?.customerId, // Replace or retrieve from context/authentication
        customerName: userInfo?.username,
        orderDate: formattedDate,
        deliveryDate: "",
        orderStatus: "orderplaced",
        paymentStatus: "pending",
        currency: "INR",
        orderItems: [
          {
            productId: parts?._id, // assuming productId is from params or part
            productName: parts?.name || "Product Name", // You might need to adjust
            quantity: quantity,
            unitPrice: parts?.price || 0,
            totalPrice: (parts?.price || 0) * quantity,
          },
        ],
        tax: 5,
      };

      const response = await Axios.post("/order/create", orderData);
      setMessage("Product order successfully!");
    } catch (error) {
      console.error("Error adding to cart:", error);
      setMessage("Error adding product to cart.");
    }
  };

  const calculateAverageRating = (reviews) => {
    if (!reviews || reviews.length === 0) return "No reviews yet"; // Handle no reviews case
    const totalRating = reviews.reduce((sum, review) => sum + review.rating, 0);
    return (totalRating / reviews.length).toFixed(1); // Round to 1 decimal place
  };

  const sectionStyle = {
    backgroundImage: "url('images/slide1.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const handleQuantityChange = (amount) => {
    setQuantity((prev) => Math.max(1, prev + amount)); // Prevents quantity < 1
  };

  return (
    <>
{parts?._id && (
  <SEO
    title={parts.seo?.metaTitle || `${parts.name} | Asia Parts`}
    description={
      parts.seo?.metaDescription ||
      parts.description ||
      "Buy genuine auto spare parts at Asia Parts"
    }
    keywords={
      Array.isArray(parts.seo?.metaKeywords)
        ? parts.seo.metaKeywords.join(", ")
        : ""
    }
    canonical={`https://asiapartsouq.com/singleproduct/${parts._id}`}
    ogImage={parts.images?.[0]?.url || "https://asiapartsouq.com/images/no-image.jpg"}
    ogUrl={`https://asiapartsouq.com/singleproduct/${parts._id}`}
  />
)}

      <section id="banner" style={{ width: "100%" }}>
        <div className="Main-div">
          <TopNavBar />
          <div className="TopSearchBar">
            <TopSearchBar />
          </div>
          <div className="single-product-container container py-4">
            <style>{`
        .single-product-card{background:linear-gradient(180deg,#fff,#fbfdff);border-radius:12px;padding:18px;box-shadow:0 6px 20px rgba(33,37,41,0.06)}
        .product-gallery{min-height:320px}
        .thumb-img{height:64px;object-fit:cover;border-radius:8px;border:1px solid transparent;cursor:pointer}
        .thumb-img.selected{border-color:#1b52a3}
        .main-img{width:100%;height:100%;object-fit:contain;border-radius:8px}
        .price-row{display:flex;align-items:center;gap:.75rem}
        .old-price{text-decoration:line-through;color:#8a8d93}
        .badge-modern{background:#eef6ff;color:#0b5ed7;padding:4px 8px;border-radius:999px;font-weight:600;font-size:.8rem}
        .pill{display:inline-block;padding:.25rem .6rem;border-radius:999px;background:#f3f6f9;color:#253047;font-size:.78rem}
        .tab-btn{border:none;background:transparent;padding:.5rem 1rem;cursor:pointer}
        .tab-btn.active{border-bottom:3px solid #1b52a3}
        .specs-list li{padding:.25rem 0}
        .review{border-top:1px solid #eef2f6;padding:12px 0}
        .related-card{border-radius:10px;overflow:hidden}

        /* Responsive tweaks */
        @media (max-width: 767.98px){
          .product-gallery{min-height:220px}
          .thumb-img{height:52px}
        }
      `}</style>

            <div
              className="single-product-card row gx-4 align-items-center"
            >
              {/* Left: Gallery */}
              <div className="col-12 col-lg-6">
                <div className="product-gallery p-2 d-flex flex-column gap-2">
                  <div
                    className="ratio ratio-4x3 bg-white p-3 d-flex align-items-center justify-content-center"
                    style={{ borderRadius: 10 }}
                  >
                    <img
                      src={
                        parts.images?.[selectedImage]?.url ||
                        "/images/no-image.jpg"
                      }
                      alt={product.title}
                      className="main-img"
                      onError={(e) => {
                        e.target.onerror = null; // prevents infinite loop if fallback fails
                        e.target.src = "/images/no-image.jpg"; // fallback image
                      }}
                    />
                  </div>

                  <div className="d-flex gap-2 mt-2 overflow-auto">
                    {parts?.images?.map((src, i) => (
                      <img
                        src={src.url || "/images/no-image.jpg"}
                        alt={`thumb-${i}`}
                        className={`thumb-img ${
                          selectedImage === i ? "selected" : ""
                        } ${!src.url ? "no-image" : ""}`}
                        onClick={() => setSelectedImage(i)}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/images/no-image.jpg";
                          e.target.classList.add("no-image");
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* Right: Details */}
              <div className="col-12 col-lg-6">
                <div className="p-2">
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h2 style={{ marginBottom: 6, fontSize: 22 }}>
                        {" "}
                        {toTitleCase(parts.name)}
                      </h2>
                      <div className="text-muted" style={{ fontSize: 13 }}>
                        {" "}
                        {toTitleCase(brand.name)}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 700 }}>
                        {" "}
                        {calculateAverageRating(reviews)} ⭐
                      </div>
                      <div style={{ fontSize: 12, color: "#6c757d" }}>
                        {" "}
                        {reviews.length} reviews
                      </div>
                    </div>
                  </div>

                  <div className="mt-3">
                    <div className="price-row">
                      <div style={{ fontSize: 24, fontWeight: 800 }}>
                        Request for price
                      </div>
                      {/* <div className="old-price">{formatPrice(product.oldPrice)}</div>
                <div className="pill">Save 28%</div> */}
                    </div>

                    <div className="mt-2 d-flex gap-2">
                      {product.badges.map((b, i) => (
                        <div key={i} className="badge-modern">
                          {b}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="mt-4 d-flex gap-2 align-items-center">
                    {userInfo ? (
                      !isInCart ? (
                        <>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <button
                              className="btn btn-outline-secondary"
                              onClick={() => handleQuantityChange(-1)}
                            >
                              -
                            </button>
                            <input
                              type="number"
                              value={quantity}
                              onChange={(e) =>
                                setQuantity(
                                  Math.max(1, Number(e.target.value) || 1)
                                )
                              }
                              style={{ width: 72, textAlign: "center" }}
                              className="form-control"
                            />
                            <button
                              className="btn btn-outline-secondary"
                              onClick={() => handleQuantityChange(1)}
                            >
                              +
                            </button>
                          </div>
                          <button
                            className="btn btn-primary"
                            style={{ minWidth: 160 }}
                            onClick={addToCart}
                          >
                            Add to Cart
                          </button>
                        </>
                      ) : (
                        <Link to={`/viewcart/${parts?._id}`}>
                          {" "}
                          <button
                            className="btn btn-primary"
                            style={{ minWidth: 160 }}
                          >
                            View Cart
                          </button>
                        </Link>
                      )
                    ) : (
                      <button
                        className="btn btn-primary"
                        style={{
                          minWidth: 220,
                          backgroundColor: "#1a53a4",
                          border: "none",
                          minHeight: "40px",
                        }}
                        onClick={handleLoginRedirect}
                      >
                        Login For Request
                      </button>
                    )}

                    {/* <button className="btn btn-outline-primary">Buy Now</button> */}
                  </div>

                  <div className="mt-3 d-flex flex-column gap-2">
                    <small className="text-muted">
                      {" "}
                      <span>
                        Body Type :{" "}
                        <span className="text-secondary fw-bold">
                          {toTitleCase(parts.bodyType)}
                        </span>
                      </span>
                    </small>
                    <small className="text-muted">
                      {" "}
                      <span>
                        Engine :{" "}
                        <span className="text-secondary fw-bold">
                          {toTitleCase(parts.engine)}
                        </span>
                      </span>
                    </small>
                    <small className="text-muted">
                      {" "}
                      <span>
                        Category :{" "}
                        <span className="text-secondary fw-bold">
                          {toTitleCase(category.name)}
                        </span>
                      </span>
                    </small>
                    <small className="text-muted">
                      {" "}
                      <span
                        className="text-secondary fw-bold"
                        style={{
                          fontSize: "15px",
                          fontFamily: "revert-layer",
                          textAlign: "justify",
                          display: "inline-block", // To allow justified text within span
                          maxWidth: "100%", // Ensure it wraps naturally
                        }}
                      >
                        {parts?.description || "No description available."}
                      </span>
                    </small>
                    <small className="text-muted">
                      {" "}
                      <strong>Part Number:</strong>{" "}
                      <span className="text-secondary fw-bold">
                        {" "}
                        {toTitleCase(parts.partNo)}
                      </span>
                    </small>
                    <small className="text-muted"> </small>
                  </div>
                </div>
              </div>

              {/* Tabs: Features / Catalogs / Reviews */}
              <div className="col-12 mt-3">
                <div className="d-flex border-bottom" style={{ gap: 12 }}>
                  <button
                    className={`tab-btn ${tab === "features" ? "active" : ""}`}
                    onClick={() => setTab("features")}
                  >
                    Features
                  </button>
                  <button
                    className={`tab-btn ${tab === "catalogs" ? "active" : ""}`}
                    onClick={() => setTab("catalogs")}
                  >
                    Catalogs
                  </button>
                  <button
                    className={`tab-btn ${tab === "reviews" ? "active" : ""}`}
                    onClick={() => setTab("reviews")}
                  >
                    Reviews ({reviews.length})
                  </button>
                </div>

                <div className="tab-content p-3">
                  {tab === "features" && (
                    <div className="row">
                      <div className="col-md-6">
                        <h5>Key features</h5>
                        <ul className="specs-list">
                          <li>
                            • Brand: <b>{toTitleCase(brand.name)}</b>
                          </li>
                          <li>
                            • Model:
                            <b>{toTitleCase(model.name)}</b>{" "}
                          </li>
                          <li>
                            • Series :<b>{toTitleCase(series.name)}</b>{" "}
                          </li>
                          <li>
                            • Region :<b>{toTitleCase(region.name)}</b>{" "}
                          </li>
                          <li>
                            • Body Type :<b>{toTitleCase(parts.bodyType)}</b>{" "}
                          </li>
                        </ul>
                      </div>

                      <div className="col-md-6">
                        <h5>Tech specs</h5>
                        <ul className="specs-list">
                          <li>
                            {" "}
                            Transmission Type :
                            <b>{toTitleCase(parts.transmissionType)}</b>{" "}
                          </li>
                          <li>
                            {" "}
                            Engine :<b>{toTitleCase(parts.engine)}</b>{" "}
                          </li>
                          <li>
                            {" "}
                            Transmission Type :
                            <b>{toTitleCase(parts.transmissionType)}</b>{" "}
                          </li>
                          <li>
                            {" "}
                            Grade : <b>{toTitleCase(parts.grade)}</b>{" "}
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}

                  {tab === "catalogs" && (
                    <div>
                      <h5>Downloads & catalogs</h5>
                      <div className="d-flex flex-column flex-sm-row gap-2">
                        {Array.isArray(parts?.catalogue) &&
                        parts.catalogue.length > 0 ? (
                          <div className="col-lg-4">
                            {parts.catalogue.map((catalogue, i) => (
                              <a
                                key={i}
                                href={catalogue.url}
                                target="_blank"
                                download
                                className="d-inline-block p-2 border rounded"
                                style={{
                                  minWidth: 200,
                                  textDecoration: "none",
                                  color: "#000",
                                  margin: "10px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <span style={{ flexGrow: 1 }}>
                                  {catalogue.name}
                                </span>
                                <i
                                  className="fa-solid fa-download"
                                  style={{
                                    marginLeft: "10px",
                                    marginRight: "0",
                                  }}
                                ></i>
                              </a>
                            ))}
                          </div>
                        ) : (
                          <img
                            src="/images/no-data.avif"
                            style={{
                              width: "250px",
                              marginLeft: "30%",
                            }}
                          />
                        )}
                        {/* {
                    product.catalogs.map((c, i) => (
                    <a key={i} href={c.href} download className="d-inline-block p-2 border rounded" style={{ minWidth: 200 }}>{c.name}</a>
                  ))} */}
                      </div>
                    </div>
                  )}

                  {tab === "reviews" && (
                    <div>
                      <h5>Customer reviews</h5>
                      <div>
                        {reviews.map((r, i) => (
                          <div key={i} className="review">
                            <div className="d-flex justify-content-between align-items-start">
                              <div>
                                <strong>{r.customerName}</strong>
                                <div style={{ fontSize: 13, color: "#6c757d" }}>
                                  {new Date(r.createdAt).toLocaleDateString()}
                                </div>
                              </div>
                              <div style={{ fontWeight: 700 }}>
                                {r.rating} ⭐
                              </div>
                            </div>
                            <p style={{ marginTop: 8 }}>{r.note}</p>
                          </div>
                        ))}

                        <div className="mt-3">
                          {userInfo && (
                            <a
                              href="#write-review"
                              className="text-primary"
                              onClick={() => setIsModalOpen(true)}
                            >
                              Write a review
                            </a>
                          )}
                        </div>
                        <ReviewModal
                          isOpen={isModalOpen}
                          onClose={() => setIsModalOpen(false)}
                          id={id}
                          userInfo={userInfo}
                          setReviews={setReviews}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Related products */}
              <div className="col-12 mt-4">
                <h5>Related products</h5>
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 mt-2">
                  {relatedProducts.length > 0 ? (
                    relatedProducts.map((p) => (
                      <div key={p._id} className="col">
                        <div className="card related-card p-2 h-100">
                          <img
                            src={p.images?.[0]?.url || "/images/no-image.jpg"}
                            alt={p.name}
                            className={p.images?.[0]?.url ? "" : "no-image"}
                            style={{
                              height: 140,
                              width: "100%",
                              objectFit: "cover",
                            }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/images/no-image.jpg";
                              e.target.classList.add("no-image");
                            }}
                          />

                          <div className="card-body p-2">
                            <h6 className="card-title mb-1">{p.name}</h6>
                            <div className="d-flex justify-content-between align-items-center">
                              <div style={{ fontWeight: 700 }}>
                                Request for Price
                                {/* {p.price > 0
                              ? `₹${p.price.toFixed(2)}`
                              : "Request for price"}  */}
                              </div>
                              <Link to={`/singleproduct/${p._id}`}>
                                <button className="btn btn-sm btn-outline-primary">
                                  View
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-muted">No related products found.</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SingleProduct;
